import { render, staticRenderFns } from "./mdUserFile.vue?vue&type=template&id=3863b39b&scoped=true&"
import script from "./mdUserFile.vue?vue&type=script&lang=js&"
export * from "./mdUserFile.vue?vue&type=script&lang=js&"
import style0 from "./mdUserFile.vue?vue&type=style&index=0&id=3863b39b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3863b39b",
  null
  
)

export default component.exports